<script>
  /**
   * @type {{
   *   links: Array<{ platform: string, url: string }>,
   *   iconStyle?: 'filled' | 'outline' | 'minimal',
   *   theme?: string
   * }}
   */
  let { links = [], iconStyle = 'filled', theme = 'clean' } = $props()

  const isMinimal = $derived(theme === 'minimal')
  const isNeubrutalism = $derived(theme === 'neubrutalism')
  const isNature = $derived(theme === 'nature')

  // Platforms that need fill instead of stroke
  const FILL_PLATFORMS = new Set(['kakao', 'tiktok', 'spotify'])

  function isFillIcon(platform) {
    return FILL_PLATFORMS.has(platform)
  }

  function getSocialIcon(platform) {
    const icons = {
      email: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
      linkedin: 'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-4 0v7h-4v-7a6 6 0 016-6zM2 9h4v12H2zM4 6a2 2 0 100-4 2 2 0 000 4z',
      twitter: 'M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z',
      github: 'M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22',
      kakao: 'M12 3C7.03 3 3 6.48 3 10.8c0 2.7 1.52 5.1 3.84 6.6l-.96 3.6 4.08-2.16c.66.12 1.32.18 2.04.18 4.97 0 9-3.48 9-7.8C21 6.48 16.97 3 12 3z',
      instagram: 'M16 3H8a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5V8a5 5 0 00-5-5zM12 16a4 4 0 110-8 4 4 0 010 8zm4.5-8.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z',
      youtube: 'M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.94 2C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 001.94-2A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z',
      spotify: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 14.36c-.2.3-.56.4-.86.2-2.36-1.44-5.34-1.76-8.84-.96-.34.08-.66-.14-.74-.46-.08-.34.14-.66.46-.74 3.84-.88 7.12-.5 9.78 1.1.3.18.38.56.2.86zm1.22-2.72c-.24.38-.74.5-1.1.24-2.7-1.66-6.82-2.14-10.02-1.18-.4.12-.82-.1-.94-.5-.12-.4.1-.82.5-.94 3.64-1.1 8.18-.56 11.3 1.34.36.24.48.72.26 1.04zm.1-2.82c-3.24-1.92-8.56-2.1-11.64-1.16-.5.14-1.02-.14-1.16-.64-.14-.5.14-1.02.64-1.16 3.54-1.08 9.42-.86 13.14 1.34.44.26.6.84.34 1.28-.26.46-.84.6-1.28.34h-.04z',
      tiktok: 'M9 12a4 4 0 104 4V4a5 5 0 005 5',
      facebook: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z',
      threads: 'M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017C1.5 8.418 2.35 5.564 3.995 3.512 5.845 1.208 8.598.027 12.179.003h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.592 12c.024 3.088.715 5.5 2.054 7.164 1.43 1.78 3.63 2.691 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.214.451-2.327 1.45-3.134.853-.689 2.017-1.089 3.37-1.163 1-.054 1.94.022 2.818.208-.083-.93-.39-1.65-.917-2.132-.63-.574-1.576-.862-2.813-.856l-.025.001c-1.01.008-1.863.285-2.535.825l-1.304-1.594c1.025-.822 2.282-1.25 3.822-1.255l.04-.001c1.752-.009 3.12.445 4.065 1.348.846.81 1.338 1.944 1.467 3.378.572.188 1.104.437 1.593.744 1.088.683 1.901 1.618 2.354 2.703.764 1.828.856 4.556-1.263 6.636-1.784 1.754-3.986 2.517-7.123 2.54z',
      website: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0zM2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z',
    }
    return icons[platform] || icons.website
  }
</script>

{#if links.length > 0}
  <div
    class="social-row-header"
    class:social-outline={iconStyle === 'outline'}
    class:social-minimal={iconStyle === 'minimal'}
    class:theme-minimal={isMinimal}
    class:theme-neubrutalism={isNeubrutalism}
    class:theme-nature={isNature}
  >
    {#each links as social}
      <a href={social.url} class="social-icon" aria-label={social.platform}>
        {#if isFillIcon(social.platform)}
          <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <path d={getSocialIcon(social.platform)} />
          </svg>
        {:else}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d={getSocialIcon(social.platform)} />
          </svg>
        {/if}
      </a>
    {/each}
  </div>
{/if}

<style>
  .social-row-header {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 12px 0 16px;
  }

  .social-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    color: var(--text-secondary);
    text-decoration: none;
    transition: all 200ms ease;
  }

  .social-icon:hover {
    color: var(--accent, var(--text-primary));
    background: color-mix(in srgb, var(--accent, var(--text-primary)) 10%, var(--card-bg, #f1f5f9));
    transform: translateY(-2px);
  }

  .social-icon svg {
    width: 18px;
    height: 18px;
  }

  .social-outline .social-icon {
    background: transparent;
    border: 1.5px solid var(--accent);
    color: var(--accent);
  }

  .social-minimal .social-icon {
    background: transparent;
    border-color: transparent;
    color: var(--text-secondary);
  }

  .theme-minimal .social-icon {
    background: transparent;
    border: 1px solid var(--divider);
  }

  .theme-neubrutalism .social-icon {
    border: 3px solid var(--text-primary);
    box-shadow: 3px 3px 0px var(--text-primary);
    border-radius: 4px;
    background: var(--page-bg);
    transition: all 100ms ease;
  }

  .theme-neubrutalism .social-icon:hover {
    box-shadow: 1px 1px 0px var(--text-primary);
    transform: translate(2px, 2px);
  }

  .theme-nature .social-icon {
    border: 1px solid var(--card-border);
    border-radius: 9999px;
    background: var(--card-bg);
    color: var(--avatar-bg);
    transition: all 250ms ease;
  }

  .theme-nature .social-icon:hover {
    border-color: var(--accent);
    color: var(--accent);
    transform: scale(1.05);
  }
</style>
